import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import { fontSize, media, space } from '../../../theme/tokens';
import * as common from '../../common/elements/Form';

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 44rem;
  margin: 0 auto;

  /* validation and server error messages */
  & > p,
  & > ${common.FieldGroup} > p {
    margin: ${space[1]} 0 0;
    font-size: ${fontSize.sm};
    color: ${({ theme }) => theme.errorMessage};
    text-align: center;
  }
`;

export const LoginButton = styled(common.Button).attrs(({ $variant }) => ({
  $variant: $variant || 'brand',
}))`
  margin-top: ${space[4]};
`;

export const StudentLoginButton = styled(common.Button)`
  margin-top: ${space[3]};
`;

export const LoadingContainer = styled.div`
  margin-top: ${space[5]};
`;

export const LoginInput = styled(common.FieldInput)`
  font-size: ${fontSize.lg};
  padding: ${space[1]} 0;
`;

export const LogoImg = styled.img`
  /* app logo size */
  height: 9.6rem;
  margin-top: ${space[5]};

  ${media.md`
    height: 12rem;
    margin-top: ${space[7]};
  `}
`;

export const IsStaffButton = styled(common.ResetButton)`
  ${media.md`
    margin-top: ${space[5]};
  `}
`;

export * from '../../common/elements/Assessments';
export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
